module.exports = __webpack_public_path__ + "2427560f084dae56cc6c487e68207395.jpg";